/* --------------------------------------------------------------
 * Questlog Header-Suche (Claude, 23.10.2026)
 * Vorschlaege beim Tippen fuer jedes [data-ql-hsearch] (Desktop und
 * Mobil), aus Shopifys /search/suggest.json. Enter fuehrt wie bisher
 * auf die Suchseite.
 * -------------------------------------------------------------- */
(function () {
  var roots = document.querySelectorAll('[data-ql-hsearch]');
  if (!roots.length) return;

  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function price(p) {
    var n = parseFloat(p);
    if (isNaN(n)) return '';
    try { return n.toLocaleString('de-DE', { style: 'currency', currency: currency }); }
    catch (e) { return n.toFixed(2) + ' €'; }
  }

  function thumb(url) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=96';
  }

  roots.forEach(function (root) {
    var input = root.querySelector('[data-ql-hsearch-input]');
    var box = root.querySelector('[data-ql-hsearch-results]');
    var form = root.querySelector('form');
    var popular = root.querySelector('template[data-ql-hsearch-popular]');
    var timer = null, last = '', active = -1;

    function hide() { box.hidden = true; box.innerHTML = ''; active = -1; input.setAttribute('aria-expanded', 'false'); }

    // Beliebte Reiseziele, solange noch nichts getippt ist (nur wo das Snippet sie mitliefert)
    function showPopular() {
      if (!popular) return false;
      box.innerHTML = popular.innerHTML;
      // Preis wie in den Suchvorschlaegen formatieren
      Array.prototype.forEach.call(box.querySelectorAll('[data-ql-cents]'), function (el) {
        el.textContent = price(parseInt(el.getAttribute('data-ql-cents'), 10) / 100);
      });
      box.hidden = false;
      active = -1;
      input.setAttribute('aria-expanded', 'true');
      return true;
    }

    function render(products, q) {
      var html;
      if (!products.length) {
        html = '<p class="ql-hsearch__empty">Kein Reiseziel gefunden. <a href="/pages/contact">Schreib uns</a> – fast jedes Ziel ist möglich.</p>';
      } else {
        html = products.map(function (p) {
          var img = p.image || (p.featured_image && p.featured_image.url) || '';
          return '<a class="ql-hsearch__item" href="' + esc(p.url) + '">' +
            (img ? '<img src="' + esc(thumb(img)) + '" alt="" width="48" height="48" loading="lazy">' : '<span class="ql-hsearch__ph"></span>') +
            '<span class="ql-hsearch__name">' + esc(p.title) + '</span>' +
            '<span class="ql-hsearch__price">' + esc(price(p.price)) + '</span></a>';
        }).join('') +
        '<a class="ql-hsearch__all" href="/search?type=product&q=' + encodeURIComponent(q) + '">Alle Treffer anzeigen</a>';
      }
      box.innerHTML = html;
      box.hidden = false;
      active = -1;
      input.setAttribute('aria-expanded', 'true');
    }

    function search(q) {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (q !== last) return;
          render((d.resources && d.resources.results && d.resources.results.products) || [], q);
        })
        .catch(function () {});
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      last = q;
      clearTimeout(timer);
      if (q.length < 2) { if (!showPopular()) hide(); return; }
      timer = setTimeout(function () { search(q); }, 200);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length < 2) showPopular();
      else if (box.innerHTML) box.hidden = false;
      // Handy: Feld im Hero unter den Header rollen, damit die Tastatur die Vorschlaege nicht verdeckt
      if (root.classList.contains('ql-hsearch--hero') && mobileQuery.matches) {
        setTimeout(function () {
          var header = document.querySelector('.ql-header');
          var offset = (header ? header.getBoundingClientRect().bottom : 70) + 12;
          window.scrollTo({ top: root.getBoundingClientRect().top + window.pageYOffset - offset, behavior: 'smooth' });
        }, 250);
      }
    });

    // Pfeiltasten durch die Vorschlaege, Escape schliesst
    input.addEventListener('keydown', function (e) {
      var items = box.querySelectorAll('a');
      if (e.key === 'Escape') { hide(); return; }
      if (!items.length || box.hidden) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        active = (active + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
        items[active].focus();
      }
    });
    box.addEventListener('keydown', function (e) {
      var items = box.querySelectorAll('a');
      if (e.key === 'Escape') { hide(); input.focus(); return; }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        active = (active + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
        items[active].focus();
      }
    });

    document.addEventListener('click', function (e) { if (!root.contains(e.target)) hide(); });

    form.addEventListener('submit', function (e) { if (!input.value.trim()) e.preventDefault(); });

    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-autocomplete', 'list');

    root._qlHide = hide;
  });

  /* --- Oeffnen ueber das vorhandene Lupensymbol ---------------------
     Das Theme oeffnet beim Klick auf [data-show-search-trigger] seine
     Such-Ueberlagerung. Hier wird der Klick vorher (Capture-Phase)
     abgefangen und stattdessen das Feld im Header auf- bzw. zugeklappt:
     auf dem Handy die Zeile unter der Kopfleiste, sonst das Feld neben
     den Symbolen. */
  var mobileQuery = window.matchMedia('(max-width: 798px)');

  function current() {
    // Neuer Header: eine Pille fuer Handy und Desktop
    for (var b = 0; b < roots.length; b++) {
      if (roots[b].classList.contains('ql-hsearch--bar')) return roots[b];
    }
    var want = mobileQuery.matches ? 'mobile' : 'desktop';
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].classList.contains('ql-hsearch--' + want)) return roots[i];
    }
    return null;
  }

  function setToggles(open) {
    var t = document.querySelectorAll('[data-ql-search-toggle]');
    for (var i = 0; i < t.length; i++) t[i].setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function close(root) {
    root.classList.remove('is-open');
    if (root._qlHide) root._qlHide();
    setToggles(false);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-show-search-trigger], [data-ql-search-toggle]');
    if (!trigger) return;
    var root = current();
    if (!root) return;
    e.preventDefault();
    e.stopPropagation();
    if (root.classList.contains('is-open')) { close(root); setToggles(false); return; }
    root.classList.add('is-open');
    setToggles(true);
    var input = root.querySelector('[data-ql-hsearch-input]');
    if (input) input.focus();
  }, true);

  // Klick daneben schliesst ein leeres Feld
  document.addEventListener('click', function (e) {
    for (var i = 0; i < roots.length; i++) {
      var r = roots[i];
      if (!r.classList.contains('is-open') || r.contains(e.target)) continue;
      if (e.target.closest && e.target.closest('[data-show-search-trigger], [data-ql-search-toggle]')) continue;
      var inp = r.querySelector('[data-ql-hsearch-input]');
      if (inp && !inp.value.trim()) close(r);
    }
  });

  // Escape im Feld schliesst es ganz
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].classList.contains('is-open') && roots[i].contains(document.activeElement)) close(roots[i]);
    }
  });
})();
